import { Component, OnInit, Inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AuthService } from '../../services/auth/auth.service';

@Component({
  selector: 'app-share-report-popup',
  templateUrl: './share-report-popup.component.html',
  styleUrls: ['./share-report-popup.component.css']
})
export class ShareReportPopupComponent implements OnInit {
  public emailAddress: string;
  public emailText = 'Hi, \n Please find attachment, you have received a report from ePeople Asia Pacific.';
  public emailTextName = ` The report was generated by ${this.auth.user.name}.`;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any ,
    public dialogRef: MatDialogRef<ShareReportPopupComponent> ,
    public auth: AuthService) { }

  ngOnInit() {}

  cancel() {
    this.dialogRef.close('Cancel');
  }

  share() {
    this.dialogRef.close({'emailAddress': this.emailAddress, 'emailText': this.emailText + ' ' + this.emailTextName });
  }

}
